import React from 'react'

const Footer = () => {

    const year = new Date().getFullYear();
    return (
        <>
            <footer>
                <div className="footer" style={{color: "#ffffffad", background: "#0E0E0E", width: "100%", height: "12vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p>Copyright &copy; {year} | All rights reserved </p>
                </div>
            </footer>

        </>
    )
}

export default Footer;